import forDate from '../utils/forDate';
/**
 * Vraci naformatovany retezec ISO datumu dle zadaneho datumu.
 *
 * @param {Date | string} [d]
 *
 * @returns {string} Naformatovany retezec
 */

var dateIsoFormatter = function dateIsoFormatter(d) {
  return forDate(d, function (td) {
    var year = td.getFullYear();
    var month = "00".concat(td.getMonth() + 1).slice(-2);
    var day = "00".concat(td.getDate()).slice(-2);
    return "".concat(year, "-").concat(month, "-").concat(day);
  });
};

export default dateIsoFormatter;